module.exports = __webpack_public_path__ + "h5/img/home10.a78599a2.png";